import React from 'react';

export const SectionHeader = ({
  title,
  section,
  expanded,
  onToggle
}: {
  title: string;
  section: string;
  expanded: boolean;
  onToggle: (section: string) => void;
}) => (
  <button
    onClick={() => onToggle(section)}
    className="w-full flex items-center justify-between p-3 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors rounded-lg mb-2"
  >
    <h4 className="font-semibold text-gray-800 dark:text-gray-200">{title}</h4>
    <svg
      className={`h-5 w-5 text-gray-500 dark:text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </button>
);
